module.exports = __webpack_public_path__ + "static/img/heroImg.cac8080.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/heroImg.png
// module id = +Oyp
// module chunks = 1